<script lang="ts">
  /**
   * The undo snackbar (STEP_8_SPEC.md §2, D1): fixed at the bottom of the
   * stage while a page dismissal is armed.
   *
   * Presentational ONLY — the container owns the arm, the single `setTimeout`
   * that authors at expiry, and (since R4.7) the display ticker that reads the
   * arm's deadline. The number below is that ticker's `secondsLeft`; the
   * component keeps no clock of its own.
   */
  import Icon from './Icon.svelte';
  import Undo2 from 'lucide/dist/esm/icons/undo-2.mjs';

  interface Props {
    count: number;
    /** Whole seconds left in the armed window (R4.7). */
    secondsLeft: number;
    onUndo: () => void;
  }

  let { count, secondsLeft, onUndo }: Props = $props();
</script>

<div class="undo-snackbar" data-testid="undo-snackbar" role="status" aria-live="polite">
  <!--
    The live region announces the snackbar ONCE. The trailing count is
    `aria-hidden` because the container ticks it every second — left in the
    accessible text, a polite live region would re-announce "in N seconds"
    on every tick. The countdown number is a visual affordance.
  -->
  <span class="undo-snackbar-label">
    Dismissing {count} item{count === 1 ? '' : 's'}{' '}<span aria-hidden="true">in {secondsLeft} second{secondsLeft === 1 ? '' : 's'}…</span>
  </span>
  <button class="action" type="button" data-testid="undo-snackbar-action" onclick={onUndo}>
    <Icon node={Undo2} />
    [ Undo ]
  </button>
</div>
